import { render } from "./Bilder.vue?vue&type=template&id=72e8d1dd"
import script from "./Bilder.vue?vue&type=script&lang=js"
export * from "./Bilder.vue?vue&type=script&lang=js"

import "./Bilder.vue?vue&type=style&index=0&id=72e8d1dd&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__